var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-filters-pagination',{attrs:{"stateModule":"forms/list","filters":_vm.filters,"total":_vm.total,"header":_vm.$t('FORMS.LIST.TABLE_HEADER'),"moreFilters":false},on:{"change":_vm.doFilter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }